module.exports = __webpack_public_path__ + "../resources/img/ic_re_welcome_glass_arc_img.05de8991.svg";